export default {
  text: 'Ai plasat o comandă cu mai puțin de 15 minute în urmă! Confirmă dacă dorești să continui cu această comandă nouă sau să gestionezi comanda existentă.',
  buttons: {
    see_existing_order: 'Vezi comanda existentă',
    proceed_new_order: 'Continuă comanda nouă',
  },
};
